/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_BitInputs */

const en_method_bit = /** @type {(inputs: Method_BitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bit`)
};

const he_method_bit = /** @type {(inputs: Method_BitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביט`)
};

/**
* | output |
* | --- |
* | "bit" |
*
* @param {Method_BitInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_bit = /** @type {((inputs?: Method_BitInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_BitInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_bit(inputs)
	return he_method_bit(inputs)
});